export default __webpack_public_path__ + "static/media/Already exists in the mind.5bbb5aa1.jpg";